import React from 'react';
import { connect } from 'react-redux';

import { withStyles, WithStyles } from '@material-ui/core/styles';
import { Theme } from "@material-ui/core/styles";

import Typography from '@material-ui/core/Typography';

import { Actions, AppState, store } from 'appredux'

import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import { Trans } from 'react-i18next';

import BackspaceIcon from '@mui/icons-material/Backspace';


// import { gusService, Nip, PrefiksPl, telefonService } from 'api';

import { Grid, TextField } from '@material-ui/core';

//import { sendErrorLog } from 'common/helpers';


interface DialogErrorProps extends WithStyles<typeof styles>  {
  //classes?: any,
  page?: any,

  open: boolean,
  number: number,
  close: (focusNext: boolean) => void,
  setNumber: (field: string, value: any, shouldValidate?: boolean | undefined) => void,
  fieldName: string,
  //setNumber: () => void,
  title: string,
  placeholder: string,
  //openGalery: () => void,
  phoneMode? :boolean,
  nipMode? :boolean,
  max?: number,
  error?: string,
  oknoSms?: boolean,
  
}

let numberSpaces = (str: string) => {
   return str.split('').map((d, i) => (i) % 3 == 0 ? ' ' + d : d).join('').trim()
}

class DialogError extends React.Component<DialogErrorProps, any> {
    stylInputaRezerwacja: React.CSSProperties = { padding: "11px 14px", textAlign: "left", fontWeight: "bold", fontSize: "1.25rem" };

  constructor(props: any) {
    super(props, {});
  }
  state = {
    numer: this.props.number === 0 ? "" : this.props.max ? this.props.number.toString().substring(0, this.props.max) : this.props.number.toString(),
    error: "",
    title: "",
    check: false
  };

  componentDidUpdate(prevProps: DialogErrorProps) {
    if (prevProps.open !== this.props.open) {
      let n = this.props.number === 0 ? "" : this.props.max ? this.props.number.toString().substring(0, this.props.max) : this.props.number.toString()
      this.setState({numer: n, title: "", check: false, error: ""})
    
      // if(this.props.phoneMode){
      //   this.phoneErrors(n)
      // }
      // if(this.props.nipMode){
      //   this.sprawdzNIP2(n)
      // }
    }
   
  }

  
 
  setNumer = (event: React.ChangeEvent<{ name?: string; value: unknown; }>) => {
 
    if ((event.target.value as string).toString().length <= (this.props.max || 99)) {
      this.setState({ numer: event.target.value })
    }

    if(this.state.check){
      //if(this.props.phoneMode){
      //  this.phoneErrors(event.target.value as string)
      //}
      //if(this.props.nipMode){
      //  this.sprawdzNIP2(event.target.value as string)
      //}
    }
    
  
    if(event.target.value && event.target.value !== "0")
        this.stylInputaRezerwacja = { ...this.stylInputaRezerwacja, backgroundColor: "rgb(232, 240, 254)" };
    else  
        this.stylInputaRezerwacja = { ...this.stylInputaRezerwacja, backgroundColor: "rgb(255, 255, 255)" };  
  }

  addToNumer = (n: number) => {
    if (this.state.numer.length < (this.props.max || 99)) {
      let num = this.state.numer + n.toString()
      this.setState({numer: num})

      if(this.state.check){
        //if(this.props.phoneMode){
        //  this.phoneErrors(num)
        //}
        //if(this.props.nipMode){
        //  this.sprawdzNIP2(num)
        //}
      }
  
    }
  } 

  clear = () => {
    let num = this.state.numer
    num = num.slice(0, -1);
    this.setState({numer: num})
  }

  clearAll = () => {
    this.setState({numer: ""})
  }

  setValue = () => {   
    if(!this.props.oknoSms && !this.props.phoneMode && !this.props.nipMode){
      this.props.setNumber(this.props.fieldName, this.state.numer.toString(), true)  
      this.props.close(true)
    } else if(this.state.check || this.props.oknoSms){
      this.props.setNumber(this.props.fieldName, this.state.numer.toString(), true)  
      this.props.close(true)
    } else {

      this.setState({check: true})
      //if(this.props.phoneMode){
      //  this.phoneErrors(this.state.numer, true)
      //}
      //if(this.props.nipMode){
      //  this.sprawdzNIP2(this.state.numer, true)
      //}

    }
   
  }

  
  // phoneErrors = async (phone: string, accept: boolean = false): Promise<string> => {
  //   const { classes } = this.props;

  //   if (phone.length < 9) {
  //     this.setState({error: "Niepoprawny numer telefonu"})
  //     return "Niepoprawny numer telefonu"
  //   }

  //   if(this.props.page.czarnaLista.find((x: {tel: string}) => phone.includes(x.tel))){
  //     //czarna lista
  //     this.setState({error: "Niepoprawny numer telefonu"})
  //     return "Niepoprawny numer telefonu"
  //   }

  //   if(!this.poprawnyPolskiNumer(phone, 0, 2, this.props.page.prefiksyPl)){
  //     this.setState({error: "Niepoprawny numer telefonu"})
  //     return "Niepoprawny numer telefonu"
  //   }

  //   try {
  //     let res = await telefonService.sprawdzNrTelefonu({ nrTelefonu: phone }, {})

  //     if (Number(res.result) > 0) {
  //       this.setState({error: ""})
  //       if(accept){
  //         this.props.setNumber(this.props.fieldName, this.state.numer.toString(), true)  
  //         this.props.close(true)
  //       }
  //       return ""
  //     }
  //     this.setState({error: "Niepoprawny numer telefonu"})
  //     return "Niepoprawny numer telefonu"

  //   } catch (error) {
  //     sendErrorLog("0", "-1", 'vscSms/sms/sprawdzNrTelefonu')
  //     await store.dispatch(Actions.pageState.addFcmLogMessage("vscSms/sms/sprawdzNrTelefonu", 2))
  //     console.log(error);
  //   }
  //   this.setState({error: ""})
  //   if(accept){
  //     this.props.setNumber(this.props.fieldName, this.state.numer.toString(), true)  
  //     this.props.close(true)
  //   }
  //   return ""
  // }

  // poprawnyPolskiNumer = (phone: string, start: number, end: number, prefiksy: PrefiksPl[]): boolean => {
  //   let ret = false
  //   if(prefiksy.length === 0) return true
  //   prefiksy.forEach(x => {
  //     if(phone.substring(start, end) === x.prefiks) ret = true
  //   })
  //   return ret
  // }

  // sprawdzNIP2 = async (nip: string, accept: boolean = false) => {
  //   nip = nip.split(" ").join("")
  //   if(!nip) {
  //     this.setState({error: "", title: ""})
  //     if(accept){
  //       this.props.setNumber(this.props.fieldName, this.state.numer.toString(), true)  
  //       this.props.close(true)
  //     }
  //     return false
  //   }
  //   if(nip.length < 9 || nip.length > 10) {
  //     this.setState({error: "Niepoprawny numer NIP", title: ""})
  //     return true
  //   } 
  //   try {
  //     let NIP: Nip = await gusService.dajDanePoNip({ nip: nip })
  //     if (NIP.nazwa) {
  //       this.setState({error: "", title: NIP.nazwa})
  //       if(accept){
  //         this.props.setNumber(this.props.fieldName, this.state.numer.toString(), true)  
  //         this.props.close(true)
  //       }
  //       return false
  //     } else {
  //       this.setState({error: "Niepoprawny numer NIP", title: ""})
  //       return true
  //     }

  //   }
  //   catch (error) {
  //     this.setState({error: "Niepoprawny numer NIP", title: ""})
  //     await sendErrorLog("0", "-1", '/vscSms/gus/dajDanePoNip/')
  //     await store.dispatch(Actions.pageState.addFcmLogMessage("/vscSms/gus/dajDanePoNip/", 2))
  //     console.log(error)
  //   }
    
  //   return true
  // };
  


  render() {
    const classes = this.props.classes;

    return (

      <Dialog
        //disableEscapeKeyDown
        maxWidth="sm"
        classes={{paper: classes.paper}}
        open={this.props.open}
        onClose={() => this.props.close(false)}
        fullWidth               
      >
        <DialogTitle disableTypography style={{paddingBottom: "12px"}}>
          <Typography gutterBottom variant="h5" component="h2" color='primary' style={{ fontSize: "1.25rem" }} >
            <b>{ this.state.title ? this.state.title : this.props.title}</b>
          </Typography>
          <hr />
        </DialogTitle>

        <DialogContent  >
                <Grid container spacing={1}>
                    <Grid item xs={12}>
                        {/* <FormControl component="fieldset" variant="outlined" fullWidth margin='normal' >
                            <Typography gutterBottom variant="h5" component="span" color="primary">
                                <b>{"telefon nr"}</b>
                            </Typography> */}
                            <TextField
                                //label="telefon"
                                //disabled
                                id="zamowieniaTextField"
                                type="number"
                                
                                //type="phone"
                                autoFocus
                                name="phone"
                                placeholder={this.props.placeholder}
                                style={{ width: "100%" }}
                                inputProps={{ style: this.stylInputaRezerwacja }}
                                InputProps={{ classes: { input: `${classes.primaryTextField}` }, }}
                                InputLabelProps={{
                                    shrink: true,
                                  }}
                                value={this.state.numer}
                                onChange={this.setNumer}
                                variant="outlined"

                                //error={this.props.error === undefined || this.props.error === "" ? false : true}
                                //helperText={this.props.error}
                                error={this.state.error === undefined || this.state.error === "" ? false : true}
                                helperText={this.state.error}
                            //error={err}
                            //helperText={err ? "Niepoprawny numer telefonu" : ""}
                            />

                        {/* </FormControl> */}
                    </Grid>


                    <Grid item xs={4}>
                        <Button onClick={() => this.addToNumer(1)} variant="outlined" size="small" color="primary"
                            className={classes.button}  ><b>1</b></Button>
                    </Grid>
                    <Grid item xs={4}>
                        <Button onClick={() => this.addToNumer(2)} variant="outlined" size="small" color="primary"
                            className={classes.button}  ><b>2</b></Button>
                    </Grid>
                    <Grid item xs={4}>
                        <Button onClick={() => this.addToNumer(3)} variant="outlined" size="small" color="primary"
                            className={classes.button}  ><b>3</b></Button>
                    </Grid>
                    <Grid item xs={4}>
                        <Button onClick={() => this.addToNumer(4)} variant="outlined" size="small" color="primary"
                            className={classes.button}  ><b>4</b></Button>
                    </Grid>
                    <Grid item xs={4}>
                        <Button onClick={() => this.addToNumer(5)} variant="outlined" size="small" color="primary"
                            className={classes.button}  ><b>5</b></Button>
                    </Grid>
                    <Grid item xs={4}>
                        <Button onClick={() => this.addToNumer(6)} variant="outlined" size="small" color="primary"
                            className={classes.button}  ><b>6</b></Button>
                    </Grid>
                    <Grid item xs={4}>
                        <Button onClick={() => this.addToNumer(7)} variant="outlined" size="small" color="primary"
                            className={classes.button}  ><b>7</b></Button>
                    </Grid>
                    <Grid item xs={4}>
                        <Button onClick={() => this.addToNumer(8)} variant="outlined" size="small" color="primary"
                            className={classes.button}  ><b>8</b></Button>
                    </Grid>
                    <Grid item xs={4}>
                        <Button onClick={() => this.addToNumer(9)} variant="outlined" size="small" color="primary"
                            className={classes.button}  ><b>9</b></Button>
                    </Grid>
                    <Grid item xs={4}>
                        <Button onClick={() => this.clearAll()} variant="outlined" size="small" color="primary"
                            className={classes.button}  ><b>C</b></Button>
                    </Grid>
                    <Grid item xs={4}>
                        <Button onClick={() => this.addToNumer(0)} variant="outlined" size="small" color="primary"
                            className={classes.button}  ><b>0</b></Button>
                    </Grid>
                    <Grid item xs={4}>
                        <Button onClick={() => this.clear()} variant="outlined" size="small" color="primary"
                            className={classes.button}  >
                                 <BackspaceIcon style={{ width: "1em", height: "1em" }} />
                                </Button>
                    </Grid>
                   
                </Grid>





          
        </DialogContent >
        <DialogActions >

            <Button onClick={() => this.props.close(false)} variant="outlined" size="small" color="primary"
              style={{ textTransform: "none", fontSize: "0.8rem" }}
            >
                 
                 <b><Trans>Back</Trans></b>
             
            </Button>
            <Button  variant="contained" size="small" color="primary" onClick={this.setValue}
              style={{ textTransform: "none", fontSize: "0.8rem" }}
              disabled={this.props.phoneMode && (this.state.numer.length !== 9) ||
                        this.props.nipMode && (this.state.numer.length !== 0 && this.state.numer.length !== 10) ||
                        this.state.error !== ""}
            >
              <b><Trans>OK</Trans></b> 
              
            </Button>
         
         
        </DialogActions>
      </Dialog>

    );
  }
}

const styles = (theme: Theme) => ({
  paper: {
    maxWidth: "350px"
  },
  primary: {
    color: theme.palette.primary.main
  },
  actionButtons: {
    textTransform: "lowercase" as "lowercase",
    fontSize: '0.8rem'
  },
  button: {
    width: "100%",
    height: "45px",
    textTransform: "none" as "none", 
    fontSize: "1.25rem"
  },
  primaryTextField: {
    color: theme.palette.primary.main,
    backgroundColor: "white",
    textAlign: 'left' as 'left',
    fontSize: "1rem"
},

});

const mapStateToProps = (state: AppState) => ({
  page: state.pageState
});

export default connect(mapStateToProps)(withStyles(styles)(DialogError));